import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

export interface CountryData {
  /** TODO: Fill with attributes */
  placeholder: string;
}

export class CountryDataService {
  //  private httpClient = cachingHttpClient("countries", 300);
  private httpClient = makeHttpClient();

  getAll() {
    return _unwrapAxiosResponse(
      this.httpClient.get<CountryData[]>(env.countryUrl)
    );
  }

  get(id: string) {
    return _unwrapAxiosResponse(
      this.httpClient.get<CountryData>(`${env.countryUrl}/${id}`)
    );
  }
  update(id: string, data: CountryData) {
    return _unwrapAxiosResponse(
      this.httpClient.put(`${env.countryUrl}/${id}`, data)
    );
  }
}

export default CountryDataService;
